import { render } from "./VerPedidos.vue?vue&type=template&id=71cce866"
import script from "./VerPedidos.vue?vue&type=script&lang=js"
export * from "./VerPedidos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__